export default __webpack_public_path__ + "static/media/ab-girl.a54cfb10.webp";